import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['region', 'flag', 'row', 'summary']

  connect () {
    this.refresh()
  }

  regionChanged () {
    this.refresh()
  }

  flagChanged () {
    this.updateSummary()
  }

  applySuggestedRegions (event) {
    event.preventDefault()
    const suggestedRegions = JSON.parse(event.currentTarget.dataset.suggestedRegions || '[]')

    this.regionTargets.forEach(region => {
      if (suggestedRegions.includes(region.dataset.region)) region.checked = true
    })

    this.refresh()
  }

  refresh () {
    this.updateAvailability()
    this.updateSummary()
  }

  updateAvailability () {
    this.rowTargets.forEach(row => {
      this.updateRowAvailability(row)
    })
  }

  updateRowAvailability (row) {
    const region = row.querySelector('[data-regional-flags-target~="region"]')
    const rowEnabled = !!region?.checked

    row.querySelectorAll('[data-regional-flags-target~="flag"]').forEach(checkbox => {
      const supportsRegionalFlags = checkbox.dataset.supportsRegionalFlags === 'true'
      const enabled = rowEnabled && supportsRegionalFlags
      checkbox.disabled = !enabled
      if (!enabled) checkbox.checked = false
    })

    row.classList.toggle('regional-flags-row-disabled', !rowEnabled)
  }

  updateSummary () {
    const summary = {}
    this.flagTargets.filter(cb => cb.checked).forEach(checkbox => {
      const { flag, label, regionLabel } = checkbox.dataset
      if (!summary[flag]) summary[flag] = { label, regions: [] }
      summary[flag].regions.push(regionLabel)
    })

    const emptyMessage = this.summaryTarget.dataset.emptyMessage
    this.summaryTarget.innerHTML = ''

    if (Object.keys(summary).length === 0) {
      const li = document.createElement('li')
      li.className = 'js-empty-regional-flags-summary'
      li.textContent = emptyMessage
      this.summaryTarget.appendChild(li)
      return
    }

    Object.entries(summary).forEach(([flag, { label, regions }]) => {
      const li = document.createElement('li')
      li.dataset.flag = flag
      li.textContent = `${label}: ${regions.join(', ')}`
      this.summaryTarget.appendChild(li)
    })
  }
}
